import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_BreadCrumb = _resolveComponent("BreadCrumb");
    const _component_TransactionDetails = _resolveComponent("TransactionDetails");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_BreadCrumb, {
            PageTitle: _ctx.$t('pages.transactionDetails')
        }, null, 8, ["PageTitle"]),
        _createVNode(_component_TransactionDetails, { transactionID: _ctx.transactionID }, null, 8, ["transactionID"])
    ], 64));
}
